// const { OSS_DOMAIN } = require('@/config/')
const { Dialog, Toast } = require('vant')
const { getUserInfo } = require('@/utils/auth')
const { baseApi, orderApi } = require('@/api')
// const debug = process.env.NODE_ENV != 'production'
const debug = false
// 微信支付
class WxPay {

    constructor (opts, callback) {
        // 微信注册状态
        this.wxReistered = false
        this.callback = callback
        if (this.checkLogin()) {

            this.createOrder(opts)
        }
    }
    // 登录校验
    checkLogin () {
        const userMobile = getUserInfo().bindingMobile
        
        if (!userMobile) {
            Dialog.alert({
                message: '请先登录',
            }).then(() => {
                
            })
        }
        return !!userMobile
    }

    // 微信config
    wxConfig () {
        if (!this.wxReistered) {
            baseApi.getWxConfig({
                url: location.href
            }).then(res => {
                if (res.success) {
                    const params = res.data
                    wx.config({
                        debug,
                        appId: params.appId,
                        timestamp: params.timestamp,
                        timeStamp: params.timestamp,
                        nonceStr: params.nonceStr,
                        signature: params.signature,
                        jsApiList: ['chooseWXPay']
                    })
                    this.wxReistered = true
                }
            })
        }
        return this
    }
    // 生成订单并获取支付参数
    createOrder (opts) {
        const toast = Toast.loading({
            duration: 0,
            forbidClick: true,
        })
        orderApi.createV2(opts).then(res => {
            toast.close()
            if (res.success) {
                // 免费订单会直接支付成功
                if (res.data.orderStatus == 1) {
                    this.callback && this.callback(res.data)
                }
                // 微信支付
                else {
                    this.wxConfig()
                    wx.ready(() => {
                        let params
                        try {
                            params = JSON.parse(res.data.wx_data_package)
                        } catch (error) {
                            Toast.fail('支付参数解析出错！')
                        }
                        params && wx.chooseWXPay({
                            timestamp: params.timestamp,
                            nonceStr: params.noncestr,
                            package: params.package,
                            signType: params.signType,
                            paySign: params.sign,
                            success: res => {
                                this.callback && this.callback(res)
                            },
                            cancel () {
                                Toast.fail('支付已取消')
                            },
                            fail () {
                                Toast.fail('支付失败')
                            }
                        })
                    })
                }
            } else {
                Toast.fail(res.errMessage)
            }
        })
    }
}

module.exports = {
    WxPay
}